module.exports = __webpack_public_path__ + "img/resize-icon-tr.e0dc34fd.svg";